import { render, staticRenderFns } from "./ListSalesDeliveryPage.vue?vue&type=template&id=aeb6562e"
import script from "./ListSalesDeliveryPage.vue?vue&type=script&lang=js"
export * from "./ListSalesDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports